import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  imports: [],
  template: `<div class="absolute inset-0 z-50
         bg-white/60 dark:bg-black/40
          items-center justify-center flex flex-col">
          <!-- <p-progressSpinner strokeWidth="4"></p-progressSpinner> -->
          <img src="images/logo.png" alt="Loading" class="w-12 h-12 logo-loader" />
          <p class="mt-3 text-center text-xs text-gray-600 dark:text-gray-300">
            Loading...
          </p>`,
  styles: `
  .logo-loader {
  animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.08);
    opacity: 0.7;
  }
}`,
})
export class Loader {

}
